import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemContent,
  ColorPaletteProp,
  ListDivider,
  Sheet,
  Table,
  iconButtonClasses,
  Button,
  IconButton,
  Card,
  Input,
  ButtonGroup,
  Option,
  Dropdown,
  MenuButton,
  Menu,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  FormControl,
  FormLabel,
  Stack,
  Select,
  MenuItem,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle, StatusBadge } from "../../../components";
import { formatDate } from "../../../utils";

import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import {
  fetchStaffReset,
  fetchStaffRequest,
  addStaffReset,
  addStaffRequest,
  viewStaffRequest,
  viewStaffReset,
} from "../../../store/actions";

import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import {
  CalendarMonthOutlined,
  FilterAltOutlined,
  PersonAddOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
  WarningRounded,
} from "@mui/icons-material";
import { STATUS } from "../../../constant";
import { NAVIGATE_TO_STAFFVIEWPAGE } from "../../../route/types";

const MobileViewTable = ({ data, props }) => {
  return (
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      {data.map((listItem, index) => (
        <List
          key={index}
          size="sm"
          sx={{
            "--ListItem-paddingX": 0,
          }}
        >
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <ListItemContent
              sx={{ display: "flex", gap: 2, alignItems: "start" }}
            >
              <div>
                <Typography fontWeight={600} gutterBottom>
                  {listItem.first_name +
                    " " +
                    listItem.middle_name +
                    " " +
                    listItem.last_name}
                </Typography>
                <Typography level="body-xs" gutterBottom>
                  <b>Role:</b>{" "}
                  {
                    {
                      1: "Admin",
                      2: "Manager",
                      3: "Sale Officer",
                      4: "Quality Assurance Personnel",
                    }[listItem.role]
                  }
                </Typography>
                <Typography level="body-xs" gutterBottom>
                  <b>Mobile:</b> {listItem.mobile_num}
                </Typography>
                <Typography level="body-xs" gutterBottom>
                  <b>Email: </b>
                  {listItem.email}
                </Typography>

                <Dropdown>
                  <MenuButton variant="plain" size="sm">
                    More ...
                  </MenuButton>
                  <Menu placement="bottom-end" sx={{ p: 1 }}>
                    <Typography level="body-sm" gutterBottom>
                      <b>Created at:</b> {formatDate(listItem.created_at)}
                    </Typography>
                    {/* <Typography level="body-sm" gutterBottom><b>Last Login: </b>{formatDate(listItem.last_login)}</Typography> */}
                  </Menu>
                </Dropdown>
              </div>
            </ListItemContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                rowGap: 1,
              }}
            >
              <StatusBadge
                color={
                  {
                    1: "success",
                    2: "warning",
                    3: "danger",
                    4: "danger",
                    5: "neutral",
                  }[listItem.status] as ColorPaletteProp
                }
              >
                {
                  {
                    1: "Active",
                    2: "Inactive",
                    3: "Locked",
                    4: "Rejected",
                    5: "Pending",
                  }[listItem.status]
                }
              </StatusBadge>
              <ButtonGroup variant="soft" size="sm">
                <Button color="primary" onClick={() => props.view(listItem)}>
                  <RemoveRedEyeOutlined />
                </Button>
              </ButtonGroup>
            </Box>
          </ListItem>
          <ListDivider />
        </List>
      ))}
    </Box>
  );
};

const DesktopViewTable = ({ data, props }) => {
  return (
    <React.Fragment>
      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          display: { xs: "none", md: "flex", lg: "flex" },
          // width: '100%',
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground":
              "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground":
              "var(--joy-palette-background-level1)",
            "--TableCell-paddingY": "4px",
            "--TableCell-paddingX": "8px",
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,
              bgcolor: "var(--TableCell-headBackground)",
            },
          }}
        >
          <thead>
            <tr style={{ textAlign: "center" }}>
              <th style={{ width: 100, padding: "10px 6px" }}>Name</th>
              <th style={{ width: 100, padding: "10px 6px" }}>Role</th>
              <th style={{ width: 100, padding: "10px 6px" }}>Mobile</th>
              <th style={{ width: 140, padding: "10px 6px" }}>Email</th>
              <th style={{ width: 100, padding: "10px 6px" }}>Created at</th>
              <th style={{ width: 100, padding: "10px 6px" }}>Status</th>
              <th aria-label="last" style={{ width: 140, padding: "10px 6px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>
                  <Typography level="body-sm">
                    {row.first_name +
                      " " +
                      row.middle_name +
                      " " +
                      row.last_name}
                  </Typography>
                </td>
                <td>
                  <Typography level="body-sm">
                    {
                      {
                        1: "Admin",
                        2: "Manager",
                        3: "Sale Officer",
                        4: "Quality Assurance Personnel",
                      }[row.role]
                    }
                  </Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.mobile_num}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.email}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">
                    {formatDate(row.created_at)}
                  </Typography>
                </td>
                <td>
                  <StatusBadge
                    color={
                      {
                        1: "success",
                        2: "warning",
                        3: "danger",
                        4: "danger",
                        5: "neutral",
                      }[row.status] as ColorPaletteProp
                    }
                  >
                    {
                      {
                        1: "Active",
                        2: "Inactive",
                        3: "Locked",
                        4: "Rejected",
                        5: "Pending",
                      }[row.status]
                    }
                  </StatusBadge>
                </td>
                <td>
                  <ButtonGroup variant="soft" size="sm">
                    <Button
                      title="View"
                      color="primary"
                      onClick={() => props.view(row)}
                    >
                      <RemoveRedEyeOutlined />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </React.Fragment>
  );
};

const StaffPage = ({
  loginResult,

  staffListStatus,
  staffListResult,
  staffListErrorMessage,

  addStaffStatus,
  addStaffResult,
  addStaffErrorMessage,

  viewStaffStatus,
  viewStaffResult,
  viewStaffErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width:600px)");

  const { state } = useLocation();
  const { partner_id } = state || {};

  const [agentData, setAgentData] = useState([]);

  const [formModal, setFormModal] = useState(false);

  const [fname, setFName] = useState("");
  const [sname, setSName] = useState("");
  const [lname, setLName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [staff_id, setStaffID] = useState("");

  useEffect(() => {
    if (staffListStatus === STATUS.SUCCESS) {
      setAgentData(staffListResult);
      // dispatch(fetchStaffReset())
    } else if (staffListStatus === STATUS.ERROR) {
      setAgentData([]);
      toast.error(staffListErrorMessage);
      dispatch(fetchStaffReset());
    }

    if (addStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff added successful");
      setFormModal(false);
      dispatch(
        fetchStaffRequest(loginResult.token, {
          id: partner_id || loginResult.owner_id,
        }),
      );
      dispatch(addStaffReset());
    } else if (addStaffStatus === STATUS.ERROR) {
      toast.error(addStaffErrorMessage);
      dispatch(addStaffReset());
    }

    if (viewStaffStatus === STATUS.SUCCESS) {
      // toast.success("Staff viewed successful");
      navigate(NAVIGATE_TO_STAFFVIEWPAGE, {
        state: {
          staff_id: staff_id,
        },
      });
      // dispatch(viewStaffReset());
    } else if (viewStaffStatus === STATUS.ERROR) {
      toast.error(viewStaffErrorMessage);
      dispatch(viewStaffReset());
    }
  });

  useEffect(() => {
    dispatch(
      fetchStaffRequest(loginResult.token, {
        id: partner_id || loginResult.owner_id,
      }),
    );
  }, []);

  /* -------- FUNCTION TO SEARCH ------ */
  const [search, setSearch] = useState("");
  const [filterBy, setFilterBy] = useState("name");

  // filtre by  name
  const filteredData = agentData.filter((item) => {
    if (filterBy === "name") {
      return (
        item.first_name.toLowerCase().includes(search.toLowerCase()) ||
        item.middle_name.toLowerCase().includes(search.toLowerCase()) ||
        item.last_name.toLowerCase().includes(search.toLowerCase())
      );
    } else if (filterBy === "mobile") {
      return item.mobile_num.includes(search);
    } else if (filterBy === "date") {
      return item.created_at.includes(search);
    } else if (filterBy === "email") {
      return item.email.toLowerCase().includes(search.toLowerCase());
    } else {
      return (
        item.first_name.toLowerCase().includes(search.toLowerCase()) ||
        item.middle_name.toLowerCase().includes(search.toLowerCase()) ||
        item.last_name.toLowerCase().includes(search.toLowerCase())
      );
    }
  });

  /* ------ pagination functions ------- */
  const [currentPage, setCurrentPage] = useState(0);
  const ITEMS_PER_PAGE = 20;
  const pageLength = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(0, prevPage - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageLength - 1));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE,
  );
  /* ---- end of pagination functions ------- */

  /* -------- actions ----------- */

  const goToViewPage = (details) => {
    const data = {
      id: details.id,
    };
    setStaffID(details.id);
    dispatch(viewStaffRequest(loginResult.token, data));
  };

  const openAddForm = () => {
    setFName("");
    setSName("");
    setLName("");
    setMobile("");
    setEmail("");
    setFormModal(true);
  };

  const submitForm = (event) => {
    event.preventDefault();
    if (fname && sname && lname && email && mobile) {
      const data = {
        id: partner_id,
        first_name: fname,
        middle_name: sname,
        last_name: lname,
        email: email,
        mobile_num: mobile,
        role: role,
      };
      dispatch(addStaffRequest(loginResult.token, data));
    } else {
      toast.error("Please fill all required information");
    }
  };

  const handleRoleSelection = (event, newValue) => {
    setRole(newValue);
  };

  const checkLoading = () => {
    if (
      staffListStatus === STATUS.LOADING ||
      addStaffStatus === STATUS.LOADING ||
      viewStaffStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box>
      <PageTitle title={"Manage Staffs"} />

      <LoadingView loading={checkLoading()} />

      {/* search */}
      <Sheet
        className="SearchAndFilters"
        sx={{
          display: "flex",
          my: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          // width: { xs: 'auto', md: '30%' },
          justifyContent: "space-between",
        }}
      >
        {/* only admin can add partner user */}
        {loginResult.role === 1 && (
          <Button
            startDecorator={<PersonAddOutlined />}
            color="success"
            sx={{ width: "auto" }}
            onClick={openAddForm}
          >
            Add new Staff
          </Button>
        )}

        {agentData.length > 0 && (
          <Input
            size="sm"
            placeholder={`Search by ${filterBy}`}
            type={
              { date: "date", name: "text", email: "email", mobile: "number" }[
                filterBy
              ]
            }
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            startDecorator={
              filterBy === "date" ? <CalendarMonthOutlined /> : <SearchIcon />
            }
            endDecorator={
              <Dropdown>
                <MenuButton variant="plain">
                  {/* <Typography level="body-sm">Filter</Typography> */}
                  <FilterAltOutlined />
                </MenuButton>
                <Menu sx={{ minWidth: "120px", fontSize: "14px" }}>
                  <MenuItem
                    onClick={() => setFilterBy("name")}
                    selected={filterBy == "name"}
                  >
                    Name
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("mobile")}
                    selected={filterBy == "mobile"}
                  >
                    Mobile
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("email")}
                    selected={filterBy == "email"}
                  >
                    Email
                  </MenuItem>
                  <MenuItem
                    onClick={() => setFilterBy("date")}
                    selected={filterBy == "date"}
                  >
                    Created at
                  </MenuItem>
                </Menu>
              </Dropdown>
            }
            sx={{
              width: { xs: "auto", md: "30%" },
              textTransform: "capitalize",
            }}
          />
        )}
      </Sheet>

      {agentData.length > 0 ? (
        <>
          {/* ------ render different view depend on plafform -------- */}
          <MobileViewTable
            data={paginatedData}
            props={{ view: goToViewPage, role: loginResult.role }}
          />
          <DesktopViewTable
            data={paginatedData}
            props={{ view: goToViewPage, role: loginResult.role }}
          />

          {/* Pagination */}
          {agentData.length > ITEMS_PER_PAGE && (
            <Box
              className="Pagination-laptopUp"
              sx={{
                pt: 2,
                gap: 1,
                [`& .${iconButtonClasses.root}`]: { borderRadius: "50%" },
                display: "flex",
              }}
            >
              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                startDecorator={<KeyboardArrowLeftIcon />}
                onClick={handlePreviousPage}
                disabled={currentPage === 0}
              >
                {isDesktop ? "Previous" : ""}
              </Button>

              <Box sx={{ flex: 1 }} />
              {/* for desktop to display page number */}
              {Array.from({ length: pageLength }).map((_, page) => (
                <IconButton
                  key={page}
                  size="sm"
                  variant={"outlined"}
                  color="neutral"
                  onClick={() => handlePageChange(page)}
                  disabled={currentPage === page}
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  {page + 1}
                </IconButton>
              ))}

              {/* for mobile to display page number */}
              <Typography
                level="body-sm"
                mx="auto"
                textAlign={"center"}
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                Page {currentPage + 1} of {pageLength}
              </Typography>
              <Box sx={{ flex: 1 }} />

              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                endDecorator={<KeyboardArrowRightIcon />}
                onClick={handleNextPage}
                disabled={currentPage === pageLength - 1}
              >
                {isDesktop ? "Next" : ""}
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            top: "20%",
          }}
        >
          <WarningRounded
            sx={{ fontSize: "50px", color: "background.appcolor" }}
          />
          <Typography level="title-md">Resource not Found</Typography>
          <Typography level="body-sm" textAlign={"center"}>
            This can be either no staff list available or network issue.
          </Typography>
          <Button
            onClick={() => dispatch(fetchStaffRequest(loginResult.token))}
            startDecorator={<RefreshOutlined />}
          >
            REFRESH
          </Button>
        </Card>
      )}

      {/* ------ Modal form for add and edit staff details ------ */}
      <Modal open={formModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              top: "60px",
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose variant="outlined" onClick={() => setFormModal(false)} />
          <DialogTitle>{"Add Staff"}</DialogTitle>
          <DialogContent>Please enter staff details correct.</DialogContent>
          <Stack component="form" onSubmit={submitForm} gap={2} sx={{ mt: 2 }}>
            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* first name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>First Name</FormLabel>
                <Input
                  type="text"
                  value={fname}
                  onChange={(e) => setFName(e.target.value)}
                  placeholder="Enter your first name"
                />
              </FormControl>

              {/* second name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Middle Name</FormLabel>
                <Input
                  type="text"
                  value={sname}
                  onChange={(e) => setSName(e.target.value)}
                  placeholder="Enter your second name"
                />
              </FormControl>

              {/* last name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Last Name</FormLabel>
                <Input
                  type="text"
                  value={lname}
                  onChange={(e) => setLName(e.target.value)}
                  placeholder="Enter your third name"
                />
              </FormControl>
            </Stack>

            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* mobile number */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Mobile number</FormLabel>
                <Input
                  type="tel"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="Enter staff phone number"
                />
              </FormControl>

              {/* email */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter staff email"
                />
              </FormControl>
            </Stack>

            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* role */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Role</FormLabel>
                <Select
                  placeholder="Select agent ownership"
                  value={role}
                  onChange={handleRoleSelection}
                  required
                >
                  <Option value="1">Admin</Option>
                  <Option value="2">Manager</Option>
                  <Option value="3">Sales Officer</Option>
                  <Option value="4">Quality Assurance Personnel</Option>
                </Select>
              </FormControl>
            </Stack>

            <Stack gap={4} sx={{ mt: 2 }}>
              <Button type="submit" fullWidth>
                Submit
              </Button>
            </Stack>
          </Stack>
        </ModalDialog>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ staff, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    staffListResult,
    staffListStatus,
    staffListErrorMessage,

    addStaffStatus,
    addStaffResult,
    addStaffErrorMessage,

    viewStaffStatus,
    viewStaffResult,
    viewStaffErrorMessage,
  } = staff;

  return {
    loginResult,

    staffListStatus,
    staffListResult,
    staffListErrorMessage,

    addStaffStatus,
    addStaffResult,
    addStaffErrorMessage,

    viewStaffStatus,
    viewStaffResult,
    viewStaffErrorMessage,
  };
};

export default connect(mapStateToProps, {})(StaffPage);
